class LiveMap {
    constructor(loader) {
        const cache = new Map();
        this.get = key => {
            if (cache.has(key)) return cache.get(key);
            const value = loader(key);
            cache.set(key, value);
            return value;
        };
    }
}

export default LiveMap;



// WEBPACK FOOTER //
// ./app/data/util/LiveMap.js